import React from 'react';
import { withRouter } from 'react-router-dom';

// Most of the time all we need is to “scroll to the top”
// because there is a long content page, that when navigated to,
// stays scrolled down. Ugh!
// {@link https://reacttraining.com/react-router/web/guides/scroll-restoration/scroll-to-top}
class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/common/ScrollToTop.js